<template>
  <div>
    <Card>
      <ui-info>
        Simple info
      </ui-info>
    </Card>
  </div>
</template>

<script setup lang="ts">
import Card from '@/stories/utils/card.vue';

</script>
